var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _path3, _path4, _path5, _path6, _path7, _rect8, _rect9, _rect10, _path8, _path9, _path10, _path11, _rect11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect12, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _polygon, _polygon2, _path36, _g, _path37, _path38, _g2, _path39, _path40, _path41, _path42, _path43, _polygon3, _path44, _path45, _path46, _path47, _path48, _polygon4, _path49, _path50, _circle, _path51, _path52, _path53, _rect13, _rect14, _path54, _path55, _rect15, _circle2, _circle3, _circle4, _rect16, _path56, _path57, _rect17, _rect18, _rect19, _rect20, _path58, _path59, _rect21, _circle5, _circle6, _circle7, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _path77, _path78, _path79, _path80, _polygon5, _polygon6, _path81, _g3, _path82, _path83, _g4, _path84, _path85, _path86, _path87, _path88, _polygon7, _path89, _path90, _polygon8, _path91, _path92, _circle8, _path93, _path94, _circle9, _path95, _path96, _path97, _path98, _rect46, _path99, _rect47, _rect48, _rect49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoWorking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "740546cb-34ca-4331-8221-ac3d3fc9ee67",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1120.61,
    height: 862.52,
    viewBox: "0 0 1120.61 862.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "07a0b5f0-40d7-4714-acbe-80fa7c137a96",
    x1: 922.95,
    y1: 714.28,
    x2: 922.95,
    y2: 199.47,
    gradientTransform: "matrix(1, 0.09, -0.09, 1, 45.13, -84.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "81276d2b-ddf3-474d-b794-9223ea4701e2",
    x1: 329.5,
    y1: 708.38,
    x2: 329.5,
    y2: 197,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#07a0b5f0-40d7-4714-acbe-80fa7c137a96"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "co-working") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1089.7,507c-41.29,62.11-30.84,148.44-10.05,216.82,7,22.89,14.91,47.08,10.21,72.38-5.75,30.94-29.19,54.77-53.22,68.11-43.79,24.33-94.62,22.33-132.33-5.19-32.59-23.79-54.74-64.38-88-87C760.72,734.4,686.49,754.58,622.39,787c-45.35,22.91-95.14,52.13-138.12,33.8-30.24-12.9-49.84-47.64-59.58-85.15-4.7-18.11-7.78-37.84-17.8-51.81-6-8.3-14-14-22.29-18.63C308.89,622.47,209,654.06,135.75,606,86.32,573.6,56.91,508.46,45.93,439.31S40.36,296.61,47.7,224.23C52.91,172.8,60.38,117.78,89.07,76.55c30.35-43.61,79.58-62.18,123-56.95S293.67,50.73,326.9,82C368.43,121,406.27,170.46,459,184c35.91,9.25,74.61.57,112.35-4,63.1-7.55,125.63-3.35,187.74,1.64,59.47,4.78,119.32,10.39,175.17,30.77,39.52,14.42,70.34,43.14,107.39,62.24,24.15,12.45,51.05,14.63,73.68,31,27.88,20.15,52.52,56.69,42.83,101.84C1148.95,450.48,1111.61,474,1089.7,507Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 880.8,
    y: 256.42,
    width: 40.89,
    height: 61.9,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 884.77,
    y: 262.44,
    width: 32.94,
    height: 49.86,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 797.8,
    y: 213.42,
    width: 62.8,
    height: 61.9,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 803.9,
    y: 219.44,
    width: 50.59,
    height: 49.86,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64.62,
    y: 121.32,
    width: 191.95,
    height: 5.11,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64.62,
    y: 146.31,
    width: 191.95,
    height: 5.11,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 388.43,
    y: 452.63,
    width: 19.61,
    height: 219.14,
    fill: "#d6d6e3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.54,494.38V292.24A21.25,21.25,0,0,1,1041.79,271h0A21.25,21.25,0,0,1,1063,292.24V536.88a21.25,21.25,0,0,1-21.25,21.25H910.14a21.25,21.25,0,0,1-21.25-21.25h0a21.25,21.25,0,0,1,21.25-21.25h89.15A21.25,21.25,0,0,0,1020.54,494.38Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#aebee1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.54,494.38V292.24A21.25,21.25,0,0,1,1041.79,271h0A21.25,21.25,0,0,1,1063,292.24V536.88a21.25,21.25,0,0,1-21.25,21.25H910.14a21.25,21.25,0,0,1-21.25-21.25h0a21.25,21.25,0,0,1,21.25-21.25h89.15A21.25,21.25,0,0,0,1020.54,494.38Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#535461"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M888.92,535.74a21.25,21.25,0,0,1,21.22-20.11h89.15a21.25,21.25,0,0,0,21.25-21.25V292.24A21.25,21.25,0,0,1,1040.77,271V535.74Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#d6d6e3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.2,501.2V299.06A21.25,21.25,0,0,0,211,277.81h0a21.25,21.25,0,0,0-21.25,21.25V543.7A21.25,21.25,0,0,0,211,565H342.6a21.25,21.25,0,0,0,21.25-21.25h0a21.25,21.25,0,0,0-21.25-21.25H253.46A21.25,21.25,0,0,1,232.2,501.2Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#aebee1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M232.2,501.2V299.06A21.25,21.25,0,0,0,211,277.81h0a21.25,21.25,0,0,0-21.25,21.25V543.7A21.25,21.25,0,0,0,211,565H342.6a21.25,21.25,0,0,0,21.25-21.25h0a21.25,21.25,0,0,0-21.25-21.25H253.46A21.25,21.25,0,0,1,232.2,501.2Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#535461"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M363.82,542.56a21.25,21.25,0,0,0-21.22-20.11H253.46A21.25,21.25,0,0,1,232.2,501.2V299.06A21.25,21.25,0,0,0,212,277.84V542.56Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#d6d6e3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 776.4,
    y: 452.63,
    width: 19.61,
    height: 224.25,
    fill: "#d6d6e3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 388.43,
    y: 452.63,
    width: 19.61,
    height: 16.2,
    opacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 776.4,
    y: 452.63,
    width: 19.61,
    height: 16.2,
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M498.17,337.92q-.47,5.18-1.19,10.5h-2.77v-10.5Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M578.52,447c.06,3.55-2.5,6.46-5.67,6.46H513v-6.24H562.8c2.15,0,3.49-2.6,2.41-4.68l-45.16-91.85a4,4,0,0,0-3.5-2.26H494.21v-10.5h28.21a2.8,2.8,0,0,1,2.45,1.58l51.77,100A17,17,0,0,1,578.52,447Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#535461"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M468.6,430.34l-.82,1.38-7.67-5.12,23.73-182.47h6.11s.25.84.66,2.44C494.7,262.34,514.79,351.65,468.6,430.34Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#535461"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M490.6,246.57l-22,183.77-.82,1.38-7.67-5.12,23.73-182.47h6.11S490.19,245,490.6,246.57Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 376.97,
    y: 329.82,
    width: 189.29,
    height: 14.5,
    transform: "translate(41.16 746.52) rotate(-83.17)",
    fill: "#d6d6e3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M403.83,447.07a1.72,1.72,0,0,1-1.71,1.71h-2.56a1.71,1.71,0,0,1-1.71-1.71.83.83,0,0,1,0-.2,1.71,1.71,0,0,1,1.69-1.5h2.56a1.72,1.72,0,0,1,1.65,1.3A1.58,1.58,0,0,1,403.83,447.07Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#e3edf9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M411.5,447.07a1.72,1.72,0,0,1-1.71,1.71h-2.56a1.71,1.71,0,0,1-1.71-1.71,1.68,1.68,0,0,1,.07-.47,1.61,1.61,0,0,1,.43-.73,1.67,1.67,0,0,1,1.2-.5h2.56a1.72,1.72,0,0,1,1.57,1A1.76,1.76,0,0,1,411.5,447.07Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#e3edf9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M418.32,447.07a1.72,1.72,0,0,1-1.71,1.71h-2.56a1.71,1.71,0,0,1-1.71-1.71,1.62,1.62,0,0,1,.15-.71,1.74,1.74,0,0,1,1.55-1h2.56a1.7,1.7,0,0,1,1.71,1.71Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#e3edf9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M426,447.07a1.72,1.72,0,0,1-1.71,1.71h-2.56a1.71,1.71,0,0,1-1.4-2.69l.2-.22a1.67,1.67,0,0,1,1.2-.5h2.56a1.72,1.72,0,0,1,1.24.55A1.65,1.65,0,0,1,426,447.07Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#e3edf9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M403.78,446.66a1.58,1.58,0,0,1,.05.41,1.72,1.72,0,0,1-1.71,1.71h-2.56a1.71,1.71,0,0,1-1.71-1.71.83.83,0,0,1,0-.2Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M411.36,446.39a1.76,1.76,0,0,1,.14.67,1.72,1.72,0,0,1-1.71,1.71h-2.56a1.71,1.71,0,0,1-1.71-1.71,1.68,1.68,0,0,1,.07-.47Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M418.07,446.16a1.72,1.72,0,0,1,.26.9,1.72,1.72,0,0,1-1.71,1.71h-2.56a1.71,1.71,0,0,1-1.71-1.71,1.62,1.62,0,0,1,.15-.71Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M426,447.07a1.72,1.72,0,0,1-1.71,1.71h-2.56a1.71,1.71,0,0,1-1.4-2.69l5.2-.18A1.65,1.65,0,0,1,426,447.07Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M441.34,453.89H391.89v-2.25a3.85,3.85,0,0,1,3.72-3.85l39.66-1.37a5.88,5.88,0,0,1,6.08,5.87Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#d6d6e3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M685.31,447c-.06,3.55,2.5,6.46,5.67,6.46h59.88v-6.24H701c-2.15,0-3.49-2.6-2.41-4.68l45.16-91.85a4,4,0,0,1,3.5-2.26h22.35v-10.5H741.41A2.8,2.8,0,0,0,739,339.5l-51.77,100A17,17,0,0,0,685.31,447Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#535461"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M795.24,430.34l.82,1.38,7.67-5.12L780,244.13h-6.11s-.25.84-.66,2.44C769.13,262.34,749,351.65,795.24,430.34Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#535461"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M773.23,246.57l22,183.77.82,1.38,7.67-5.12L780,244.13h-6.11S773.64,245,773.23,246.57Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 784.97,
    y: 242.43,
    width: 14.5,
    height: 189.29,
    transform: "translate(-74.16 77.85) rotate(-6.83)",
    fill: "#d6d6e3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M860,447.07a1.72,1.72,0,0,0,1.71,1.71h2.56a1.71,1.71,0,0,0,1.71-1.71.83.83,0,0,0,0-.2,1.71,1.71,0,0,0-1.69-1.5h-2.56a1.72,1.72,0,0,0-1.65,1.3A1.58,1.58,0,0,0,860,447.07Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#e3edf9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M852.33,447.07a1.72,1.72,0,0,0,1.71,1.71h2.56a1.71,1.71,0,0,0,1.71-1.71,1.68,1.68,0,0,0-.07-.47,1.61,1.61,0,0,0-.43-.73,1.67,1.67,0,0,0-1.2-.5H854a1.72,1.72,0,0,0-1.57,1A1.76,1.76,0,0,0,852.33,447.07Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#e3edf9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M845.51,447.07a1.72,1.72,0,0,0,1.71,1.71h2.56a1.71,1.71,0,0,0,1.71-1.71,1.62,1.62,0,0,0-.15-.71,1.74,1.74,0,0,0-1.55-1h-2.56a1.7,1.7,0,0,0-1.71,1.71Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#e3edf9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M837.83,447.07a1.72,1.72,0,0,0,1.71,1.71h2.56a1.71,1.71,0,0,0,1.4-2.69l-.2-.22a1.67,1.67,0,0,0-1.2-.5h-2.56a1.72,1.72,0,0,0-1.24.55A1.65,1.65,0,0,0,837.83,447.07Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#e3edf9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M860.05,446.66a1.58,1.58,0,0,0-.05.41,1.72,1.72,0,0,0,1.71,1.71h2.56a1.71,1.71,0,0,0,1.71-1.71.83.83,0,0,0,0-.2Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M852.47,446.39a1.76,1.76,0,0,0-.14.67,1.72,1.72,0,0,0,1.71,1.71h2.56a1.71,1.71,0,0,0,1.71-1.71,1.68,1.68,0,0,0-.07-.47Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M845.76,446.16a1.72,1.72,0,0,0-.26.9,1.72,1.72,0,0,0,1.71,1.71h2.56a1.71,1.71,0,0,0,1.71-1.71,1.62,1.62,0,0,0-.15-.71Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M837.83,447.07a1.72,1.72,0,0,0,1.71,1.71h2.56a1.71,1.71,0,0,0,1.4-2.69l-5.2-.18A1.65,1.65,0,0,0,837.83,447.07Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M822.49,453.89h49.45v-2.25a3.85,3.85,0,0,0-3.72-3.85l-39.66-1.37a5.88,5.88,0,0,0-6.08,5.87Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#d6d6e3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.47,481c23.07-39.13,14.71-118.06,15.64-119.57.83-1.33-2.35-38.5-23.55-47.58-3.83-7.59-7.6-16.14-7.6-16.14a6.73,6.73,0,0,1-1.22.91q-.25-.68-.49-1.38c-.27-.79-.52-1.6-.77-2.41a15.53,15.53,0,0,0,1.81.46,7.54,7.54,0,0,0,4.84-.43,5.39,5.39,0,0,0,1.39-1.07c1.67-1.11,2.59-3.11,3.37-5l6.17-14.78c2.78-6.67,5.58-13.38,7.06-20.45a57.58,57.58,0,0,0-2.46-31.86c-1.46-3.88-3.48-7.76-6.91-10.08-6.87-4.66-16.43-1.44-24.28-4.17-2.58-.9-4.91-2.42-7.49-3.34-5.57-2-11.86-.93-17.22,1.56s-9.7,6.45-14.39,10c-2.31,1.77-6,3.6-8.72,6-2.64,2.06-4.67,4.55-4.28,7.83.44,3.75,4.39,6,8.07,6.88.61.14,1.24.25,1.86.36a36,36,0,0,0,15.37,59.8,84.36,84.36,0,0,1,4.86,10.93q.27.77.53,1.55c-6.06,1.72-10.8,3.15-11.75,3.94-2.87,2.38,3.14,23.22,3.14,23.22-1.53,1.94-3.09,4.15-4.67,6.52a140.55,140.55,0,0,0-22.16,60.57c-1,7.91-2.3,16-3.95,23.69L870,412.59l-.15,1.77-1.71-.42h0l-5.38-1.33-.21,1.21-.82-.39c-13.33-6.25-35.79-14.23-51-6-16.05,8.64,18.59,20.12,40.82,26.23-7.37.36-14.42,2.13-20,6.27-16.12,12.08,29.47,18.37,51,20.6l.87.09v.46l7.46.69,1.75.16.17,2.66s10.68,1.75,24.95,3.87c-16.29,4.07-36.42,6.89-50.4,8.54-14.82,1.74-27.44,12.06-31.42,26.45a23.52,23.52,0,0,0-.36,12.72c4.16,14.53-.92,121.42-2.07,144.44l-26.35,15.17s-41,5-13.69,14.61a56.16,56.16,0,0,0,7.53,2c-3.6,2.32-3.29,5.35,7.32,9.07,27.33,9.58,90.86-.42,90.86-.42s-1.39-11.26-3.65-20.62l.7.06s-6.56-24.41,3.39-36.72-1.67-106-1.67-106,17.42-7.21,69.49-7.68c42,10.78,62.47-27.81,62.18-47.76C1029.52,481.87,1029.5,481.41,1029.47,481Z",
    transform: "translate(-39.7 -18.74)",
    fill: "url(#07a0b5f0-40d7-4714-acbe-80fa7c137a96)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M874.25,420.36l-4.45,18s-4-.9-10-2.44c-20.32-5.26-63.18-17.89-46-27.16,14.81-8,36.62-.22,49.57,5.85,4.74,2.23,8.3,4.23,9.89,5.17C873.93,420.16,874.25,420.36,874.25,420.36Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#f8b9bf"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M873,425.44l-3.2,13s-4-.9-10-2.44l3.61-21.31c4.74,2.23,8.3,4.23,9.89,5.17Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "833.31 420.93 820.89 417.86 824.75 395.1 834.68 397.55 833.31 420.93",
    fill: "#d9dfe8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "833.31 420.93 827.95 419.61 829.97 396.39 834.68 397.55 833.31 420.93",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M992.85,345.4S969,331.62,958.4,371.15s-11.6,57.74-11.6,57.74l-75.32-15.06-2.39,27.51s80.53,26,90.66,24.11,43-57,43-57S1032.63,365.74,992.85,345.4Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.25,420.36l-4.45,18s-4-.9-10-2.44c-20.32-5.26-63.18-17.89-46-27.16,14.81-8,36.62-.22,49.57,5.85,4.74,2.23,8.3,4.23,9.89,5.17C873.93,420.16,874.25,420.36,874.25,420.36Z",
    transform: "translate(-39.7 -18.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873,425.44l-3.2,13s-4-.9-10-2.44l3.61-21.31c4.74,2.23,8.3,4.23,9.89,5.17Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "833.31 420.93 820.89 417.86 824.75 395.1 834.68 397.55 833.31 420.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "833.31 420.93 827.95 419.61 829.97 396.39 834.68 397.55 833.31 420.93",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.85,346.4S969,332.62,958.4,372.15s-11.6,57.74-11.6,57.74l-75.32-15.06-2.39,27.51s80.53,26,90.66,24.11,43-57,43-57S1032.63,366.74,992.85,346.4Z",
    transform: "translate(-39.7 -18.74)"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M841.15,651.7,810.4,669.41s-39.84,4.88-13.3,14.18,88.24-.41,88.24-.41-3.43-27.72-8.21-31.59S841.15,651.7,841.15,651.7Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#68739d"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M961,453s-15.3,8-42.48,14.91c-15.93,4-35.87,6.84-49.65,8.46A35.81,35.81,0,0,0,838.35,502,22.84,22.84,0,0,0,838,514.4c4.53,15.83-2.23,144.51-2.23,144.51l46.7,4.32s-6.37-23.71,3.3-35.66-1.62-102.91-1.62-102.91,16.92-7,67.48-7.46c46.84,12,66.14-39.27,58.91-53.64S961,453,961,453Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#6394e2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.15,651.7,810.4,669.41s-39.84,4.88-13.3,14.18,88.24-.41,88.24-.41-3.43-27.72-8.21-31.59S841.15,651.7,841.15,651.7Z",
    transform: "translate(-39.7 -18.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961,453s-15.3,8-42.48,14.91c-15.93,4-35.87,6.84-49.65,8.46A35.81,35.81,0,0,0,838.35,502,22.84,22.84,0,0,0,838,514.4c4.53,15.83-2.23,144.51-2.23,144.51l46.7,4.32s-6.37-23.71,3.3-35.66-1.62-102.91-1.62-102.91,16.92-7,67.48-7.46c46.84,12,66.14-39.27,58.91-53.64S961,453,961,453Z",
    transform: "translate(-39.7 -18.74)"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M855.57,662.45l-30.75,17.71S785,685,811.52,694.34s88.24-.41,88.24-.41-3.43-27.72-8.21-31.59S855.57,662.45,855.57,662.45Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#68739d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M966,527.95c-50.56.46-67.48,7.46-67.48,7.46s11.29,91,1.62,102.91-3.3,35.66-3.3,35.66l-46.7-4.32s.08-1.52.21-4.24c1.12-22.36,6.05-126.16,2-140.27a22.84,22.84,0,0,1,.35-12.36,35.82,35.82,0,0,1,30.51-25.69c13.77-1.61,33.71-4.41,49.64-8.46l.78-.2c26.7-6.86,41.7-14.71,41.7-14.71s42.31-3.8,49.54,10.57a17,17,0,0,1,1.48,7.25C1026.71,500.94,1006.81,538.42,966,527.95Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#6394e2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M895.57,442.79l-1.71,18.5s-4.11-.29-10.22-.93c-20.87-2.17-65.14-8.27-49.49-20,13.46-10.08,36.18-5.68,49.89-1.6,5,1.5,8.84,2.95,10.55,3.64C895.22,442.64,895.57,442.79,895.57,442.79Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#f8b9bf"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.78,321.84s-6.26,4.9-13.91,10.28c-8.39,1.9-18.13,3.47-25.15,4.49,2.51-8,1-17-1.83-24.89a93.69,93.69,0,0,0-12.55-23.08l42.32-13.21c-3.32,8.41-1.82,18,1,26.34A86.85,86.85,0,0,0,1019.78,321.84Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#f8b9bf"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M895.09,448l-1.23,13.29s-4.11-.29-10.22-.93l.4-21.61c5,1.5,8.84,2.95,10.55,3.64Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "857.52 443.33 844.78 442.15 845.2 419.07 855.39 420.01 857.52 443.33",
    fill: "#d9dfe8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.78,321.84s-6.26,4.9-13.91,10.28c-8.39,1.9-18.13,3.47-25.15,4.49,2.51-8,1-17-1.83-24.89,10.34-3,25.13-6.88,30.78-10A86.85,86.85,0,0,0,1019.78,321.84Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.32,302.22s7.08,16.07,11.54,23.33-51.82,14-51.82,14-5.84-20.23-3.05-22.55S1006.61,306.92,1011.32,302.22Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#d9dfe8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.43,481.56a50.63,50.63,0,0,1-8.76,11.34c-24.86,23.62-65.61-1-84-14.46,26.7-6.86,41.7-14.71,41.7-14.71s42.31-3.8,49.54,10.57A17,17,0,0,1,1026.43,481.56Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.83,491.21c-28.26,26.84-77-8.7-90.14-19.17-2.13-1.7-3.32-2.75-3.32-2.75,5.19-4.86,9.75-15.16,13.36-27.76A243.61,243.61,0,0,0,945,404.75a136.5,136.5,0,0,1,21.52-58.83c1.53-2.3,3-4.45,4.53-6.33,10.67-13.57,28.6-22.19,28.6-22.19,37.84-11.06,42.93,45.07,41.92,46.69S1050.68,460,1017.83,491.21Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.49,414.48s-24.33,59.4-34.06,62.79c-5.57,1.93-35.32-1.73-59.74-5.22-2.13-1.7-3.32-2.75-3.32-2.75,5.19-4.86,9.75-15.16,13.36-27.76l31.45,1.5s-1.75-18.14,2.87-58.82,30.23-30.6,30.23-30.6C1044.65,367.81,1021.49,414.48,1021.49,414.48Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "857.52 443.33 852.02 442.82 850.56 419.57 855.39 420.01 857.52 443.33",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.67,351s-25.61-10.07-30.23,30.6-2.87,58.82-2.87,58.82l-76.73-3.67,1.73,27.56s83.51,13.71,93.24,10.33,34.06-62.79,34.06-62.79S1044,365.18,1001.67,351Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.39,290.78c-1.12-6.08,5.23-6,7.51-11.72l-42.32,13.21a93.4,93.4,0,0,1,7.84,12.47,35.11,35.11,0,0,0,6.73,1.3C993.24,307,996.39,297.07,1003.39,290.78Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 984.12,
    cy: 267.59,
    r: 34.96,
    transform: "translate(587.38 1204.16) rotate(-84.72)",
    fill: "#f8b9bf"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M949.6,236c.43,3.64,4.27,5.86,7.84,6.68s7.44.86,10.57,2.77c5,3.08,6.35,9.92,5.72,15.8-.35,3.32-.85,7.39,1.87,9.32a7.25,7.25,0,0,0,2.8,1,26.26,26.26,0,0,0,8.62.3c1.68-.22,3.41-.6,5-.13,2.62.76,4.17,3.52,4.68,6.19s.23,5.45.64,8.14a16.9,16.9,0,0,0,13.32,13.74,7.33,7.33,0,0,0,4.7-.42c1.9-1,2.87-3.13,3.69-5.12l6-14.36c2.7-6.47,5.42-13,6.86-19.86a55.92,55.92,0,0,0-2.39-30.94c-1.42-3.76-3.38-7.53-6.71-9.79-6.67-4.53-16-1.4-23.58-4-2.51-.87-4.77-2.35-7.27-3.24-5.41-1.93-11.52-.91-16.73,1.52s-9.42,6.26-14,9.75C957.26,226.44,948.85,229.71,949.6,236Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M950.52,235.23c.43,3.64,4.27,5.86,7.84,6.68s7.44.86,10.57,2.77c5,3.08,6.35,9.92,5.72,15.8-.35,3.32-.85,7.39,1.87,9.32a7.25,7.25,0,0,0,2.8,1,26.26,26.26,0,0,0,8.62.3c1.68-.22,3.41-.6,5-.13,2.62.76,4.17,3.52,4.68,6.19s.23,5.45.64,8.14a16.9,16.9,0,0,0,13.32,13.74,7.33,7.33,0,0,0,4.7-.42c1.9-1,2.87-3.13,3.69-5.12l6-14.36c2.7-6.47,5.42-13,6.86-19.86a55.92,55.92,0,0,0-2.39-30.94c-1.42-3.76-3.38-7.53-6.71-9.79-6.67-4.53-16-1.4-23.58-4-2.51-.87-4.77-2.35-7.27-3.24-5.41-1.93-11.52-.91-16.73,1.52s-9.42,6.26-14,9.75C958.19,225.67,949.78,228.94,950.52,235.23Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#b96b6b"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M979.48,373.34S966.13,425.2,952.84,430s-7.42,6.16-7.42,6.16",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 925.9,
    y: 544.58,
    width: 14.51,
    height: 95.37,
    fill: "#d6d6e3"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 925.9,
    y: 544.58,
    width: 14.51,
    height: 7.07,
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M936.57,562.82v2a4.69,4.69,0,0,0,4.69,4.69h63.18a4.69,4.69,0,0,0,4.69-4.69v-2a4.69,4.69,0,0,0-4.69-4.69H941.26a4.69,4.69,0,0,0-4.69,4.69Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#d6d6e3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M937.65,559.84h70.41a4.67,4.67,0,0,0-3.62-1.71H941.26A4.67,4.67,0,0,0,937.65,559.84Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 873.56,
    y: 634.76,
    width: 119.21,
    height: 11.4,
    rx: 5.5,
    ry: 5.5,
    fill: "#d6d6e3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 986.03,
    cy: 653.42,
    r: 7.26,
    fill: "#535461"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.29,
    cy: 653.42,
    r: 7.26,
    fill: "#535461"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 933.16,
    cy: 653.42,
    r: 7.26,
    fill: "#535461"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 917.74,
    y: 427.44,
    width: 114.03,
    height: 17.62,
    rx: 8.5,
    ry: 8.5,
    fill: "#d6d6e3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M980.11,653.5s-5.7,5.63-14.51,0",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.47,455.17v1.39a7.25,7.25,0,0,1-7.25,7.25H964.69a7.25,7.25,0,0,1-7.25-7.25v-1.39Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 822.44,
    y: 452.63,
    width: 19.61,
    height: 249.86,
    fill: "#d6d6e3"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 822.44,
    y: 452.63,
    width: 19.61,
    height: 16.2,
    opacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 232.94,
    y: 551.4,
    width: 14.51,
    height: 95.37,
    fill: "#d6d6e3"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 232.94,
    y: 551.4,
    width: 14.51,
    height: 7.07,
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M316.17,569.65v2a4.69,4.69,0,0,1-4.69,4.69H248.3a4.69,4.69,0,0,1-4.69-4.69v-2A4.69,4.69,0,0,1,248.3,565h63.18a4.69,4.69,0,0,1,4.69,4.69Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#d6d6e3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M315.1,566.66H244.68A4.67,4.67,0,0,1,248.3,565h63.18A4.67,4.67,0,0,1,315.1,566.66Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 180.59,
    y: 641.58,
    width: 119.21,
    height: 11.4,
    rx: 5.5,
    ry: 5.5,
    fill: "#d6d6e3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.33,
    cy: 660.24,
    r: 7.26,
    fill: "#535461"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.06,
    cy: 660.24,
    r: 7.26,
    fill: "#535461"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.19,
    cy: 660.24,
    r: 7.26,
    fill: "#535461"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M272.64,660.32s5.7,5.63,14.51,0",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M642.81,373.22s-16.28-29.59-10.33-55.31a51.17,51.17,0,0,0-2.85-32.24A86.06,86.06,0,0,0,622,271.93",
    transform: "translate(-39.7 -18.74)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M625.61,255.69c.85,3.88-3.7,16.67-3.7,16.67s-9.49-9.7-10.35-13.58a7.19,7.19,0,1,1,14-3.09Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M641.94,274.62c-1.39,3.72-12.16,12-12.16,12s-2.7-13.3-1.3-17a7.19,7.19,0,1,1,13.47,5Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M649.5,311.44c-3.08,2.51-16.55,4.2-16.55,4.2s4.39-12.84,7.47-15.35a7.19,7.19,0,1,1,9.08,11.15Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M648.95,340.58c-2.61,3-15.6,6.94-15.6,6.94s2.15-13.4,4.76-16.39a7.19,7.19,0,1,1,10.83,9.45Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M615.2,290.59c3.38,2.09,16.95,2,16.95,2s-6-12.17-9.38-14.26a7.19,7.19,0,1,0-7.57,12.22Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M615,324.69c3.85,1,16.78-3.12,16.78-3.12s-9.37-9.82-13.22-10.8A7.19,7.19,0,0,0,615,324.69Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M619.33,357.85c3.62,1.62,17.07-.24,17.07-.24s-7.58-11.26-11.2-12.88a7.19,7.19,0,0,0-5.87,13.13Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M625.61,255.69c.85,3.88-3.7,16.67-3.7,16.67s-9.49-9.7-10.35-13.58a7.19,7.19,0,1,1,14-3.09Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M641.94,274.62c-1.39,3.72-12.16,12-12.16,12s-2.7-13.3-1.3-17a7.19,7.19,0,1,1,13.47,5Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M649.5,311.44c-3.08,2.51-16.55,4.2-16.55,4.2s4.39-12.84,7.47-15.35a7.19,7.19,0,1,1,9.08,11.15Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M648.95,340.58c-2.61,3-15.6,6.94-15.6,6.94s2.15-13.4,4.76-16.39a7.19,7.19,0,1,1,10.83,9.45Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M615.2,290.59c3.38,2.09,16.95,2,16.95,2s-6-12.17-9.38-14.26a7.19,7.19,0,1,0-7.57,12.22Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M615,324.69c3.85,1,16.78-3.12,16.78-3.12s-9.37-9.82-13.22-10.8A7.19,7.19,0,0,0,615,324.69Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M619.33,357.85c3.62,1.62,17.07-.24,17.07-.24s-7.58-11.26-11.2-12.88a7.19,7.19,0,0,0-5.87,13.13Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M636.19,455.29h0a17.14,17.14,0,0,1-17.11-18.22l4.79-75.9h24.64l4.79,75.9A17.14,17.14,0,0,1,636.19,455.29Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 63.42,
    width: 14,
    height: 58,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 101.6,
    y: 63.42,
    width: 14,
    height: 58,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 119.6,
    y: 63.42,
    width: 14,
    height: 58,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 63.42,
    width: 14,
    height: 58,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 173.6,
    y: 63.42,
    width: 14,
    height: 58,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 191.6,
    y: 63.42,
    width: 14,
    height: 58,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 74.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 110.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 101.6,
    y: 74.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 101.6,
    y: 110.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 119.6,
    y: 74.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 119.6,
    y: 110.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 74.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 110.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 155.6,
    y: 74.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 155.6,
    y: 110.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 173.6,
    y: 74.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 173.6,
    y: 110.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 191.6,
    y: 74.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 191.6,
    y: 110.42,
    width: 14,
    height: 3,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 155.6,
    y: 63.42,
    width: 14,
    height: 58,
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 257.29,
    y: 82.16,
    width: 14,
    height: 58,
    transform: "translate(-61.94 102.56) rotate(-24.84)",
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 250.36,
    y: 94.69,
    width: 14,
    height: 3,
    transform: "translate(-56.29 98.27) rotate(-24.84)",
    fill: "#2a78ff",
    opacity: 0.1
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 265.48,
    y: 127.36,
    width: 14,
    height: 3,
    transform: "translate(-68.62 107.64) rotate(-24.84)",
    fill: "#2a78ff",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M428.84,680.21,403.43,664c-.13-22.83-.49-128.82,4.26-143a23.29,23.29,0,0,0,.2-12.61c-3.3-14.41-15.34-25.17-29.93-27.54-13.76-2.24-33.56-5.91-49.5-10.65,14.21-1.47,24.86-2.74,24.86-2.74l.28-2.63,9.15-.44V464l.87-.05c21.37-1.27,66.75-5.5,51.33-18.16-5.29-4.34-12.19-6.39-19.47-7.08,22.26-5.08,57.05-14.92,41.54-24.17-14.74-8.78-37.31-1.88-50.78,3.73l-.83.35-.15-1.21-5.38,1.08h0l-1.71.34-.08-1.76-75.49,11.66a257.66,257.66,0,0,0-3.08-25.81c1.69-11.26,9.55-27.68,6.78-36.49-3.22-10.23-16.44-13.58-22-22.82-1.46-2.41-2.91-4.67-4.33-6.65a70,70,0,0,0-10.65-11.51,48.6,48.6,0,0,1,3.92-17.25,83.57,83.57,0,0,1,5.28-10.6,35.6,35.6,0,0,0,26.44-41c4.78,2.05,10.59,2.26,13.58-1.74l-1.42-.55c.14-.15.28-.3.4-.47-2.91-1.11-6-2.37-8.28-4.39a9.7,9.7,0,0,1-1.45-2.15c-1.38-2.8-1.22-6.16-2.54-9a10.41,10.41,0,0,0-2.59-3.38,17.83,17.83,0,0,0-8.46-4.84c-3.61-1.05-7.41-1.58-10.87-3a36.75,36.75,0,0,0-39.11-11l-1.25.43a16.31,16.31,0,0,0-31.81-7.2,16.27,16.27,0,0,1,4.36-9.74c-.26.22-.53.43-.78.66a16.32,16.32,0,0,0-.71,23.07l.29.28a16.39,16.39,0,0,0,4.09,3.58,16.32,16.32,0,0,1-10.76-13.37c0,.34,0,.68,0,1A16.32,16.32,0,0,0,225,230.13l.45-.05-.24.33a36.71,36.71,0,0,0,3.3,45.45,17,17,0,0,0,2.62,4.2,13.61,13.61,0,0,0,1.21,1.22,15.51,15.51,0,0,0,10.46,4.82q1,1.19,2.13,2.29a59.52,59.52,0,0,1-2.58,8.24,87.34,87.34,0,0,1-7.92,15.27c-21.6,6.14-23.5,42.82-22.72,44.21.93,1.66-3.22,59.26,12.78,128.84-.66,19.89,10.94,52.78,52.12,44.11C328.11,531.81,345,539.7,345,539.7s-4.89,89.57,2.09,102.61c4.37,8.17,1.27,20.17-2,28.64a31.47,31.47,0,0,0-2.88,6.64c-1,2.11-1.73,3.39-1.73,3.39l.7,0c-2.64,9.17-4.51,20.24-4.51,20.24s62.43,12.67,89.89,4.38c10.66-3.22,11.1-6.2,7.64-8.66a55.62,55.62,0,0,0,7.54-1.65C469.22,687,428.84,680.21,428.84,680.21Z",
    transform: "translate(-39.7 -18.74)",
    fill: "url(#81276d2b-ddf3-474d-b794-9223ea4701e2)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M293,255a36,36,0,1,1-36-36A36,36,0,0,1,293,255Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#fa595f"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M374.09,424.13l3.65,18.22s4.06-.73,10.07-2c20.53-4.35,63.91-15.09,47.11-25.11-14.45-8.61-36.58-1.84-49.78,3.66-4.84,2-8.48,3.86-10.11,4.73C374.42,423.94,374.09,424.13,374.09,424.13Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#f8b9bf"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M375.12,429.27l2.62,13.08s4.06-.73,10.07-2l-2.67-21.45c-4.84,2-8.48,3.86-10.11,4.73Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "334.79 424.74 347.33 422.23 344.49 399.32 334.45 401.33 334.79 424.74",
    fill: "#d9dfe8"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "334.79 424.74 340.2 423.65 339.21 400.38 334.45 401.33 334.79 424.74",
    opacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M258.91,344s24.41-12.72,33.28,27.25,9,58.19,9,58.19l75.92-11.73,1.18,27.59s-81.6,22.43-91.63,20.09-40.48-58.85-40.48-58.85S218.28,362.59,258.91,344Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.09,424.13l3.65,18.22s4.06-.73,10.07-2c20.53-4.35,63.91-15.09,47.11-25.11-14.45-8.61-36.58-1.84-49.78,3.66-4.84,2-8.48,3.86-10.11,4.73C374.42,423.94,374.09,424.13,374.09,424.13Z",
    transform: "translate(-39.7 -18.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,429.27l2.62,13.08s4.06-.73,10.07-2l-2.67-21.45c-4.84,2-8.48,3.86-10.11,4.73Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.79 424.74 347.33 422.23 344.49 399.32 334.45 401.33 334.79 424.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.79 424.74 340.2 423.65 339.21 400.38 334.45 401.33 334.79 424.74",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.91,346s24.41-12.72,33.28,27.25,9,58.19,9,58.19l75.92-11.73,1.18,27.59s-81.6,22.43-91.63,20.09-40.48-58.85-40.48-58.85S220.28,364.59,260.91,346Z",
    transform: "translate(-39.7 -18.74)"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M397,656.71l29.94,19s39.59,6.63,12.66,14.76-88.13-4.3-88.13-4.3,4.65-27.54,9.6-31.19S397,656.71,397,656.71Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#f37291"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M286,452.9s14.93,8.67,41.78,16.77c15.74,4.75,35.54,8.42,49.22,10.65a35.81,35.81,0,0,1,29.35,27,22.84,22.84,0,0,1-.19,12.36C400.94,535.3,402,664.15,402,664.15l-46.84,2.25s7.41-23.41-1.72-35.77S359.6,527.9,359.6,527.9s-16.59-7.74-67.09-10.43c-47.33,10-64.34-42.15-56.48-56.19S286,452.9,286,452.9Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#96a2d0"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397,656.71l29.94,19s39.59,6.63,12.66,14.76-88.13-4.3-88.13-4.3,4.65-27.54,9.6-31.19S397,656.71,397,656.71Z",
    transform: "translate(-39.7 -18.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,452.9s14.93,8.67,41.78,16.77c15.74,4.75,35.54,8.42,49.22,10.65a35.81,35.81,0,0,1,29.35,27,22.84,22.84,0,0,1-.19,12.36C400.94,535.3,402,664.15,402,664.15l-46.84,2.25s7.41-23.41-1.72-35.77S359.6,527.9,359.6,527.9s-16.59-7.74-67.09-10.43c-47.33,10-64.34-42.15-56.48-56.19S286,452.9,286,452.9Z",
    transform: "translate(-39.7 -18.74)"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M382.08,666.82l29.94,19s39.59,6.63,12.66,14.76-88.13-4.3-88.13-4.3,4.65-27.54,9.6-31.19S382.08,666.82,382.08,666.82Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#f37291"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M277.64,527.57c50.5,2.69,67.09,10.43,67.09,10.43s-4.79,87.82,2,100.6c7.25,13.56-6.48,37.9-6.48,37.9l46.84-2.25s0-1.52,0-4.24c-.14-22.38-.48-126.3,4.17-140.23a22.84,22.84,0,0,0,.19-12.36,35.82,35.82,0,0,0-29.35-27c-13.69-2.22-33.48-5.89-49.22-10.64l-.77-.24c-26.37-8-41-16.53-41-16.53s-31.19-2.16-39,11.88c-1,1.82-5.31,5.4-5.49,8.29C225.45,502.52,236.46,536.24,277.64,527.57Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#96a2d0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M351.81,445.6l.89,18.56s4.12-.11,10.26-.48c20.95-1.25,65.45-5.39,50.33-17.8-13-10.67-35.9-7.27-49.77-3.8-5.09,1.28-9,2.56-10.7,3.17C352.16,445.47,351.81,445.6,351.81,445.6Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#f8b9bf"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M233,319.29s6,5.17,13.44,10.89c8.3,2.26,18,4.27,24.93,5.6-2.15-8.15-.24-17,2.93-24.79a93.69,93.69,0,0,1,13.56-22.51l-41.7-15.07c2.95,8.55,1,18.1-2.17,26.27A86.85,86.85,0,0,1,233,319.29Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#f8b9bf"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M352.06,450.83l.64,13.33s4.12-.11,10.26-.48l.56-21.61c-5.09,1.28-9,2.56-10.7,3.17Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "309.62 446.05 322.39 445.44 322.99 422.36 312.77 422.85 309.62 446.05",
    fill: "#d9dfe8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M227.53,488.58c27,28.07,77.35-5.29,90.89-15.17,2.2-1.61,3.43-2.6,3.43-2.6-5-5.09-13-9.8-16.07-22.55a277,277,0,0,1-5.94-39.52c-.83-10.55,10.07-30.64,6.92-40.66s-16.12-13.31-21.57-22.38c-1.43-2.36-2.85-4.58-4.25-6.52-10.06-14-27.59-23.43-27.59-23.43C216,303,213.07,356.34,214,358S210.66,418.46,227.53,488.58Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M227.25,411.76s21.69,60.42,31.26,64.23c5.48,2.18,35.37-.17,59.91-2.58,2.2-1.61,3.43-2.6,3.43-2.6-5-5.09-9.07-15.58-12.13-28.32l-31.49.11s2.55-18-.27-58.89-28.85-31.9-28.85-31.9C206.18,364.12,227.25,411.76,227.25,411.76Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "309.62 446.05 315.13 445.79 317.62 422.62 312.77 422.85 309.62 446.05",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M249.85,349.21s26-8.93,28.85,31.9S279,440,279,440l76.82-.28-2.95,27.46s-84,10-93.6,6.21S228,409.17,228,409.17,206.91,361.52,249.85,349.21Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#2a78ff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M250.8,289c1.39-6-5-6.19-7-12L285.52,292a93.4,93.4,0,0,0-8.38,12.11,35.11,35.11,0,0,1-6.78,1C260.22,305.61,257.51,295.58,250.8,289Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.07,
    cy: 266.67,
    r: 34.96,
    transform: "translate(-52.19 -5.41) rotate(-2.75)",
    fill: "#f8b9bf"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M253,375.14s11.06,52.39,24.12,57.74,7.14,6.49,7.14,6.49",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M298.58,404.73s-9.24,2.89-20-10.92",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.3,
    cy: 199.26,
    r: 16,
    fill: "#fa595f"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M217.76,226.45a16,16,0,0,1,0-21.89c-.26.21-.52.42-.76.65a16,16,0,0,0,21.92,23.32c.25-.23.47-.48.69-.72A16,16,0,0,1,217.76,226.45Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#fa595f"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M226.9,232.49a16,16,0,0,1-16.84-14c0,.33,0,.66,0,1a16,16,0,1,0,31.94-2c0-.34-.07-.66-.11-1A16,16,0,0,1,226.9,232.49Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#fa595f"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M283.95,231.91c3.73,1.84,8,2.35,12,3.51s8.08,3.28,9.84,7.06c1.29,2.78,1.14,6.07,2.49,8.82,1.94,4,6.42,5.84,10.54,7.41-3.54,4.75-11.14,3.46-16.1.23s-9.23-8-15-9.25a14.08,14.08,0,0,0-14.81,6.59c-1.58,2.77-2.14,6-2.92,9.08-2,8.12-6,16.2-13,20.81s-17.43,4.58-22.92-1.73c-3.2-3.68-4.27-8.69-5.22-13.47a27.37,27.37,0,0,1-.77-6.81c.32-5.74,4.14-10.63,8-14.89,4.55-5,9.39-9.8,14.23-14.57,4.18-4.12,9-11.1,15.3-11.59C272.87,222.53,278,229,283.95,231.91Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M282.95,230.91c3.73,1.84,8,2.35,12,3.51s8.08,3.28,9.84,7.06c1.29,2.78,1.14,6.07,2.49,8.82,1.94,4,6.42,5.84,10.54,7.41-3.54,4.75-11.14,3.46-16.1.23s-9.23-8-15-9.25a14.08,14.08,0,0,0-14.81,6.59c-1.58,2.77-2.14,6-2.92,9.08-2,8.12-6,16.2-13,20.81s-17.43,4.58-22.92-1.73c-3.2-3.68-4.27-8.69-5.22-13.47a27.37,27.37,0,0,1-.77-6.81c.32-5.74,4.14-10.63,8-14.89,4.55-5,9.39-9.8,14.23-14.57,4.18-4.12,9-11.1,15.3-11.59C271.87,221.53,277,228,282.95,230.91Z",
    transform: "translate(-39.7 -18.74)",
    fill: "#fa595f"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 141.58,
    y: 434.26,
    width: 114.03,
    height: 17.62,
    rx: 8.5,
    ry: 8.5,
    fill: "#d6d6e3"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M181.28,462v1.39a7.25,7.25,0,0,0,7.25,7.25h99.53a7.25,7.25,0,0,0,7.25-7.25V462Z",
    transform: "translate(-39.7 -18.74)",
    opacity: 0.1
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 342.39,
    y: 452.63,
    width: 19.61,
    height: 249.83,
    fill: "#d6d6e3"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 342.39,
    y: 452.63,
    width: 19.61,
    height: 16.2,
    opacity: 0.1
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 333.01,
    y: 434.72,
    width: 518.42,
    height: 32.4,
    fill: "#d6d6e3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoWorking);
export default __webpack_public_path__ + "static/media/co-working.b7110db10d448793758caf4652c65198.svg";
export { ForwardRef as ReactComponent };